import { useEffect, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { Card, StyledBody } from 'baseui/card';
import { toaster } from 'baseui/toast';
import { getProjectHints } from '@gtintel/platform-api';
import { Button } from '@gtintel/platform-atoms';
import { useAsyncOp } from '@gtintel/platform-utils';
import { useMatching } from '../../context';
import FeedbackButtons from '../FeedbackButtons';
export function HintsCard({
  title
}) {
  const [css] = useStyletron();
  const matchCtx = useMatching();
  const {
    isLoading,
    fn: getHints
  } = useAsyncOp(getProjectHints);
  const [hints, setHints] = useState([]);
  const [activeDocAvailabilityHint, setActiveDocAvailabilityHint] = useState(0);
  useEffect(() => {
    getHints(matchCtx.matchHintModal.projectId).then(data => {
      setHints(data);
    }).catch(error => {
      console.log(error);
      toaster.negative('Hints failed to load' + error);
    });
  }, [getHints]);
  return <Card title={title}>
      {isLoading ? 'Loading...' : <>
          <StyledBody>{hints[activeDocAvailabilityHint]?.answer} </StyledBody>
          <div className={css({
        display: 'flex',
        justifyContent: 'space-between'
      })}>
            <Button kind="primary" onClick={() => setActiveDocAvailabilityHint(prev => prev + 1)} disabled={activeDocAvailabilityHint === hints.length - 1}>
              <ArrowLeftIcon />
            </Button>
            <FeedbackButtons />
            <Button kind="primary" onClick={() => setActiveDocAvailabilityHint(prev => prev - 1)} disabled={activeDocAvailabilityHint === 0}>
              <ArrowRightIcon />
            </Button>
          </div>
        </>}
    </Card>;
}
export default HintsCard;